import { ColorOptions } from "../types";
import { THEME } from "./theming";
/* Color Options and the contrasting colors have been defined by Design.
If you need to change the color or add to the collection contact Design to get
the correct definition. */
const MAPPED_CONTRAST_COLORS = new Map([
    [ColorOptions.Red, THEME.palette.error.light.color],
    [ColorOptions.LightGrey, THEME.palette.gray.smoke.color],
    [ColorOptions.Blue, THEME.palette.primary.light.color],
    [ColorOptions.Green, THEME.palette.success.light.color],
    [ColorOptions.Yellow, THEME.palette.warning.light.color],
    [ColorOptions.InstructorIssues, THEME.palette.instructorIssues.light.color],
    [ColorOptions.ResourceIssues, THEME.palette.resourceIssues.light.color],
]);
const MAPPED_COLORS = new Map([
    [ColorOptions.Red, THEME.palette.error.dark.color],
    [ColorOptions.LightGrey, THEME.palette.gray.slate.color],
    [ColorOptions.Blue, THEME.palette.primary.dark.color],
    [ColorOptions.Green, THEME.palette.success.dark.color],
    [ColorOptions.Yellow, THEME.palette.warning.dark.color],
    [ColorOptions.InstructorIssues, THEME.palette.instructorIssues.dark.color],
    [ColorOptions.ResourceIssues, THEME.palette.resourceIssues.dark.color],
]);
export const getColorOptions = ({ color, contrast, }) => {
    const defaultColors = {
        contrast: THEME.palette.gray.smoke.color,
        color: THEME.palette.gray.slate.color,
    };
    if (contrast) {
        return MAPPED_CONTRAST_COLORS.get(color) ?? defaultColors.contrast;
    }
    return MAPPED_COLORS.get(color) ?? defaultColors.color;
};
